import React, { useState } from 'react'
import axios from "axios"
import { useNavigate } from 'react-router-dom'
import "./style/Addproduct.css" // Import the CSS

export default function AddProduct() {
    const navigate = useNavigate()
    const [productForm, setProductForm] = useState({
        name: "",
        price: "",
        description: "",
        image: null
    })
    
     const api = "https://mkbackend-production.up.railway.app"
    const [imagePreview, setImagePreview] = useState(null)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)
    const [success, setSuccess] = useState(null)

    const handleChange = (e) => {
        setProductForm({
            ...productForm,
            [e.target.name]: e.target.value
        })
        // Clear errors on change
        if (error) setError(null)
    }

    const handleAddProduct = async (e) => {
        e.preventDefault()
        setLoading(true)
        setError(null)
        setSuccess(null)

        // Validation
        if (!productForm.name.trim()) {
            setError("Please enter a product name")
            setLoading(false)
            return
        }

        if (!productForm.price || parseFloat(productForm.price) <= 0) {
            setError("Please enter a valid price")
            setLoading(false)
            return
        }

        if (!productForm.description.trim()) {
            setError("Please enter a product description")
            setLoading(false)
            return
        }

        if (!productForm.image) {
            setError("Please select a product image")
            setLoading(false)
            return
        }

        try {
            const token = localStorage.getItem("token")
            if (!token) {
                navigate('/login')
                return
            }

            const formData = new FormData()
            formData.append("name", productForm.name.trim())
            formData.append("price", productForm.price)
            formData.append("description", productForm.description.trim())
            formData.append("image", productForm.image)

            const res = await axios.post(
                `${api}/addproduct`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )

            if (res.data.success) {
                setSuccess("✅ Product added successfully!")
                
                // Reset form
                setProductForm({
                    name: "",
                    price: "",
                    description: "",
                    image: null
                })
                setImagePreview(null)
                
                // Auto navigate after 2 seconds
                setTimeout(() => {
                    navigate('/allproducts')
                }, 2000)
            } else {
                setError(res.data.message || "Failed to add product")
            }
        } catch (err) {
            console.error(err)
            setError(err.response?.data?.message || "Error adding product. Please try again.")
        } finally {
            setLoading(false)
        }
    }

    const handleImageSelect = (e) => {
        const file = e.target.files[0]
        
        if (file) {
            // Validate file type
            if (!file.type.startsWith('image/')) {
                setError("Please select an image file")
                return
            }
            
            // Validate file size (max 5MB)
            if (file.size > 5 * 1024 * 1024) {
                setError("Image size should be less than 5MB")
                return
            }

            setProductForm(prevState => ({
                ...prevState,
                image: file
            }))
            
            const previewUrl = URL.createObjectURL(file)
            setImagePreview(previewUrl)
            setError(null)
        }
    }

    return (
        <div className="add-product-container">
            {/* Page Title */}
            <h1 className="page-title">Add New Product</h1>

            {/* Form */}
            <form className="add-product-form" onSubmit={handleAddProduct}>
                {/* Success Message */}
                {success && (
                    <div className="success-message">{success}</div>
                )}

                {/* Error Message */}
                {error && (
                    <div className="error-message">{error}</div>
                )}

                {/* Product Name */}
                <div className="form-group">
                    <label>Product Name</label>
                    <input
                        type="text"
                        placeholder="Enter product name"
                        name="name"
                        value={productForm.name}
                        onChange={handleChange}
                        disabled={loading}
                    />
                </div>

                {/* Price */}
                <div className="form-group">
                    <label>Price ($)</label>
                    <input
                        type="text"
                        placeholder="Enter price (e.g., 29.99)"
                        name="price"
                        value={productForm.price}
                        onChange={handleChange}
                        disabled={loading}
                    />
                </div>

                {/* Description */}
                <div className="form-group">
                    <label>Description</label>
                    <textarea
                        placeholder="Enter product description"
                        name="description"
                        value={productForm.description}
                        onChange={handleChange}
                        disabled={loading}
                        rows="4"
                    />
                </div>

                {/* Image Upload */}
                <div className="form-group">
                    <label>Product Image</label>
                    <div className="file-upload-wrapper">
                        <input
                            type="file"
                            name="image"
                            onChange={handleImageSelect}
                            accept="image/*"
                            disabled={loading}
                        />
                    </div>
                </div>

                {/* Image Preview */}
                {imagePreview && (
                    <div className="image-preview">
                        <img src={imagePreview} alt="Product preview" />
                    </div>
                )}

                {/* Submit Button */}
                <button 
                    type="submit" 
                    className="submit-btn"
                    disabled={loading}
                >
                    {loading ? '⏳ Adding Product...' : 'Add Product'}
                </button>
            </form>
        </div>
    )
}